import type { ICounterProps } from './components/countUp';

export function MountCountUp(props: ICounterProps, el: Element) {
	import('./async').then(a => a.MountCountUp(props, el));
}
